import React from 'react';
import Layout from "./Layout";
import AdsAssistantChat from './AdsAssistantChat';

const SponsoredDisplay = () => {
    return (
        <Layout>
            <div className="ads-page-container">
                <div className="ads-page-header">
                    <h2><i className="bi bi-display"></i> Sponsored Display</h2>
                    <p>Manage your sponsored display campaigns</p>
                </div>
                <AdsAssistantChat context="sponsored-display" />
            </div>
        </Layout>
    );
};

export default SponsoredDisplay;